import { motion } from 'framer-motion';
import ItemView from '../item/Item.view';
import { useObjectSelectionController } from '../ObjectSelection.controller';
import { DndContext } from '@dnd-kit/core';
import styles from './ObjectSelection.desktop.module.css';
import type ObjectSelectionProperties from '../ObjectSelection.properties.ts';
import LoaderView from '../../loader/Loader.view.tsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function ObjectSelectionDesktopView(props: ObjectSelectionProperties) {
  const { loading, grouped, open, handleDragEnd, toggle } = useObjectSelectionController();
  const { t } = useTranslation();

  return (
    <motion.div
      initial={{ height: 0, opacity: 0 }}
      animate={{
        height: props.isObjectSelectionOpen ? '400px' : '0px',
        opacity: props.isObjectSelectionOpen ? 1 : 0,
      }}
      transition={{ duration: 0.5 }}
      className={styles.motionContainer}
    >
      {loading && <LoaderView />}

      {!loading && (
        <DndContext onDragEnd={handleDragEnd}>
          <div className={styles.categoriesContainer}>
            {Array.from(grouped.entries()).map(([category, items]) => {
              const isOpen = open[String(category)] ?? true;

              return (
                <section key={String(category)} className={styles.category}>
                  <button
                    type="button"
                    className={styles.categoryHeader}
                    onClick={() => toggle(category)}
                    aria-expanded={isOpen}
                  >
                    <span className={styles.categoryTitle}>
                      {t(`apiCategory.${category.toUpperCase()}`)}
                    </span>

                    <span className={styles.categoryMeta}>{items.length}</span>

                    <span className={styles.categoryChevron} aria-hidden="true">
                      {isOpen ? '▾' : '▸'}
                    </span>
                  </button>

                  {isOpen && (
                    <div className={styles.categoryBody}>
                      {items.map((marketComponentType, index) => (
                        <ItemView
                          key={`${String(category)}-${marketComponentType.name}-${index}`}
                          marketComponentType={marketComponentType}
                        />
                      ))}
                    </div>
                  )}
                </section>
              );
            })}
          </div>
        </DndContext>
      )}
    </motion.div>
  );
}
